module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "cip"
    }
  }, [_c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "page.iv"
    }
  }), _vm._v("© 1996 Wm. B. Eerdmans Publishing Co.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("2140 Oak Industrial Drive N.E., Grand Rapids, Michigan 49505 /")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("P.O. Box 163, Cambridge CB3 9PU U.K.")]), _vm._v(" "), _c('p', {
    staticClass: "crt"
  }, [_vm._v("All rights reserved")]), _vm._v(" "), _c('p', {
    staticClass: "cipf"
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Moo, Douglas J.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("The Epistle to the Romans / Douglas J. Moo")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("p. cm.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("— (The new international commentary on the New Testament)")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("Includes "), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0008#BIBLIO"
    }
  }, [_vm._v("bibliographical references")]), _vm._v(" and "), _c('span', {
    staticClass: "xref",
    attrs: {
      "href": "#/eernicnt66ro0018#INDEX1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("indexes.")])]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("eISBN 978-1-4674-2269-7")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("ISBN 0-8028-2317-3")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("1. Bible. N.T. Romans—Commentaries. I. Title. II. Series.")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("BS2665.3.M55 1966")]), _vm._v(" "), _c('p', {
    staticClass: "cip"
  }, [_vm._v("227′.107—dc20          96-26077")]), _vm._v(" "), _c('p', {
    staticClass: "crtf"
  }, [_c('a', {
    staticClass: "url",
    attrs: {
      "href": "http://www.eerdmans.com",
      "target": "_blank"
    }
  }, [_vm._v("www.eerdmans.com")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e91fe11","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/eernicnt66ro0003.vue
// module id = 60
// module chunks = 0